module.exports = "<app-user-list\n  [role]=\"'ROLE_COACH'\"\n>\n</app-user-list>\n"


//////////////////
// WEBPACK FOOTER
// /dist/src/app/user/coach/coach-list/coach-list.component.html
// module id = ../../../../../src/app/user/coach/coach-list/coach-list.component.html
// module chunks = main